<template>
  <Dropdown class="citySelect">
    <a 
class="cityname" href="javascript:void(0)">
      <Icon 
type="md-pin" class="ico_sel"></Icon>
      {{ currentcity }}
      <Icon type="ios-arrow-down"></Icon>
    </a>
    <DropdownMenu 
slot="list" class="layerselect">
      <DropdownItem>
        <div class="ui-areamini-content-list">
          <div :key="value.name" 
class="item" v-for="(value, key, index) in mapselectData">
            <a
              :data-id="index"
              :class="value.select"
              href="javascript:void(0)"
              role="menuitem"
              tabindex="-1"
              @click="clickselectData(value)"
              >{{ value.name }}</a
            >
          </div>
        </div>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
import MapSelect from './MapSelect';
export default MapSelect;
</script>
<style lang="less" scoped>
.citySelect:hover {
  background: white;
}
.citySelect .ivu-select-dropdown {
  overflow: visible;
  max-height: none;
  margin-top: 0px;
  box-shadow: none;
  z-index: 999;
  left: 0px !important;
}
.citySelect a.cityname {
  color: #999;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
}

.citySelect .ico_sel {
  font-size: 16px;
  color: #00a032;
  margin-right: 4px;
}

.layerselect {
  left: 0;
  width: 300px;
  margin-top: 0px;
  box-shadow: none;
  // padding: 10px;
}
.layerselect li:hover {
  background: white;
}
.item {
  float: left;
  width: 60px;
  padding: 6px;
  padding-left: 13px;
}
.item a {
  float: left;
  padding: 0 8px;
  color: #999;
}
.item a.selected {
  background-color: #00a032;
  color: #fff;
}
.layerselect .item a:hover {
  background: #e3e4e5;
  color: #00a032;
}
.areamini_inter_list {
  list-style: none;
}

.areamini_inter {
  margin: 10px 0 10px 10px;
  float: right;
}
.areamini_inter_split {
  width: 262px;
  height: 0;
  border-bottom: 1px dotted #eee;
}
.areamini_inter_desc {
  margin: 9px 0;
  color: #8f8f8f;
}
.areamini_inter_item {
  float: left;
  width: 130px;
  height: 26px;
  // line-height: 26px;
}
.areamini_inter_lk {
  display: block;
  overflow: hidden;
  color: #999;
}
.areamini_inter_lk:hover {
  color: #00a032;
}
.areamini_inter_name {
  float: left;
  width: 120px;
  font-family: Microsoft YaHei, tahoma, arial, Hiragino Sans GB, '\5B8B\4F53', sans-serif;
}
.areamini_inter_ico {
  float: left;
  position: relative;
  top: 7px;
  margin-right: 8px;
  width: 15px;
  height: 10px;
  border: 1px solid transparent;
}
.areamini_inter_ico_global {
  background-repeat: no-repeat;
  background-position: 0 0;
  height: 12px;
  margin-top: -1px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAbCAYAAADYtRcLAAAAAklEQ…xhLXWtZyGYzFr6bN/Xe/RqOM7WT4UprKXPPrhhrcmiMIX9CRYv4u0MBGIsAAAAAElFTkSuQmCC);
}
</style>



// WEBPACK FOOTER //
// src/components/mapselect/MapSelect.vue